/* Helpers de presentación compartidos por las pantallas de Capacitaciones
 * Administrativas (TD-11629). */
import { EstadoCapacitacion, EstadoParticipante, Modalidad } from "src/services/capacitacionAdm";
import { fechaDeTextoSql as aFecha, formatFechaCorta } from "src/utils/fechas";

/** 'YYYY-MM-DD HH:MM:SS' -> 'dd/mm/aaaa hh:mm' */
export const formatFechaHora = (valor?: string | null) => {
  const d = aFecha(valor);
  if (!d) return valor || "Sin fecha";
  return d.toLocaleString("es-PY", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export { formatFechaCorta };

export const ETIQUETA_MODALIDAD: Record<Modalidad, string> = {
  PRESENCIAL: "Presencial",
  VIRTUAL: "Virtual",
};

export const ESTADO_CAPACITACION: Record<EstadoCapacitacion, { etiqueta: string; color: string }> = {
  BORRADOR: { etiqueta: "Borrador", color: "tertiary" },
  ABIERTA: { etiqueta: "Registro abierto", color: "success" },
  CERRADA: { etiqueta: "Registro cerrado", color: "medium" },
  ANULADA: { etiqueta: "Anulada", color: "danger" },
};

export const ESTADO_PARTICIPANTE: Record<EstadoParticipante, { etiqueta: string; color: string }> = {
  CONFIRMADO: { etiqueta: "Confirmó", color: "success" },
  PENDIENTE: { etiqueta: "Pendiente", color: "warning" },
  RECHAZADO: { etiqueta: "No participó", color: "danger" },
};

/** Texto para avisar cuándo se habilita la evaluación. */
export const textoEvaluacionDesde = (fechaFin?: string | null) =>
  fechaFin
    ? `La evaluación se habilita al finalizar la capacitación (${formatFechaHora(fechaFin)}).`
    : "La evaluación se habilita cuando finalice la capacitación.";

/** Mismo umbral visual que Capacitaciones Técnicas. */
export const colorPuntaje = (p: number) => (p >= 60 ? "#2e7d32" : "#c62828");
